import debounce from 'lodash-es/debounce';

export default function () {
  // Helper function to add or remove class from elements
  const toggleClass = (elements, className, add) => {
    elements.forEach((element) => {
      if (add) {
        element.classList.add(className);
      } else {
        element.classList.remove(className);
      }
    });
  };

  // Set max-height on menu hover to trigger animation and open menu
  document.addEventListener(
    'mouseenter',
    debounce((e) => {
      if (
        e.target instanceof Element &&
        (e.target.matches('[data-nav-menu-hover]') || e.target.closest('[data-nav-menu-hover]'))
      ) {
        const navMenuHoverElements = document.querySelectorAll('[data-nav-menu-hover]');
        toggleClass(Array.from(navMenuHoverElements), 'NavList__heading--active', false);

        const currentTarget = e.target.closest('[data-nav-menu-hover]');
        const menu = currentTarget.querySelector('[data-nav-menu]');
        const menuContainer = menu.querySelector('[data-nav-container]');
        const maxHeight = menuContainer.offsetHeight;

        menu.style.maxHeight = `${maxHeight}px`;
        currentTarget.classList.add('NavList__heading--active');
      }
    }, 500),
    true,
  );

  // Unset max-height to close menu
  document.addEventListener(
    'mouseleave',
    debounce((e) => {
      if (
        e.target instanceof Element &&
        (e.target.matches('[data-nav-menu-hover]') || e.target.closest('[data-nav-menu-hover]'))
      ) {
        const currentTarget = e.target.closest('[data-nav-menu-hover]');
        const menu = currentTarget.querySelector('[data-nav-menu]');
        menu.style.maxHeight = '0';
        currentTarget.classList.remove('NavList__heading--active');
      }
    }, 500),
    true,
  );
}
